import { FC, memo } from 'react';

import clsx from 'clsx';

import MainMenuNavEntry from '~/features/navigation/components/N20MainMenu/components/MainMenuNav/mainMenuNavEntry';
import IMainMenuNavigation from '~/features/navigation/components/N20MainMenu/components/MainMenuNavigation.def';
import MainMenuSearchButton from '~/features/navigation/components/N20MainMenu/components/MainMenuSearchButton/MainMenuSearchButton';
import NavigationHotLinks from '~/features/navigation/components/N20MainMenu/components/NavigationHotLinks/NavigationHotLinks';
import useMainMenuState from '~/features/navigation/components/N20MainMenu/useMainMenuState';

import styles from './mainMenuNav.module.css';

const MainMenuNav: FC<IMainMenuNavigation> = memo(({ nodes, hasMetaHeader, currentVertical }) => {
	const menuIsOpen = useMainMenuState((state) => state.menuIsOpen);
	const clearMainMenuStates = useMainMenuState((state) => state.clearMainMenuStates);

	return (
		<div className={clsx(styles.root, { [styles.hasMetaHeader]: hasMetaHeader, [styles.open]: menuIsOpen })}>
			<MainMenuSearchButton onOpen={clearMainMenuStates} />
			<nav className={styles.outerListWrapper}>
				<ul className={styles.innerListWrapper}>
					{nodes.map((node, idx) => (
						<MainMenuNavEntry
							currentVertical={currentVertical}
							key={node.id}
							isFirst={!idx}
							{...node}
						/>
					))}
				</ul>
			</nav>
			<NavigationHotLinks />
		</div>
	);
});

export default MainMenuNav;
